import getAccountProfileApi from '@/api/get/account/get-account-profile';
import updateAccountProfileApi from '@/api/patch/account-profile/update-account-profile';
import Alert from '@/components/alert/alert-component';
import Card from '@/components/card/card-component';
import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { Col, Row } from '@/components/grid/grid-component';
import { useMutation } from '@/hooks/use-api';
import { APP_CONTEXT } from '@/utils/context';
import { Heading3Text } from '@/utils/global-fonts';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountProfileForm from './account-profile-form';
import Styled from './profile-edit-style';

/**
 * Edit a profile
 * @returns {JSX.Element}
 */
const ProfileEdit = () => {
  const navigate = useNavigate();
  const { setCurrentUser, currentUser } = useContext(APP_CONTEXT);
  const [updateUser, { loading: updateAccountProfileLoading }] = useMutation(
    updateAccountProfileApi,
  );

  const onUpdateAccountProfile = (newUserDetail) => {
    updateUser(newUserDetail).then((data) => {
      setCurrentUser({ ...currentUser, ...data.data, updated: true });
      Alert({
        icon: 'success',
        text: 'Account updated successfully',
      });
    });
  };

  return (
    <Styled.Main>
      <FormWrapper
        defaultValues={async () => {
          const accountProfileData = await getAccountProfileApi();
          return accountProfileData.data;
        }}
        onSubmit={onUpdateAccountProfile}
      >
        <Card
          borderRadius={0}
          bodyStyle={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Row direction="row">
            <Col xs={12}>
              <Heading3Text>My Profile</Heading3Text>
            </Col>
          </Row>
          <AccountProfileForm loading={updateAccountProfileLoading} />
        </Card>
        <SubmitCard
          padding="0"
          isLoading={updateAccountProfileLoading}
          primaryButtonTitle="Update"
          primaryButtonType="submit"
          showSecondaryButton={false}
          primaryButtonDisabled={false}
          primaryButtonWidth="112px"
          submitClickSecondary={() => {
            navigate(-1);
          }}
        />
      </FormWrapper>
    </Styled.Main>
  );
};

ProfileEdit.propTypes = {};

export default ProfileEdit;
